import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import {
    InputGroup,
    SideCancelBtn,
    SubmitBtn,
    ActionSection,
    ScrollableContent,
    Wrapper,
    FieldWrappers,
    ModalSubHeading,
    ModalHeading,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useSelector } from "react-redux";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "./SinglePropSelectModal";
import Config from "../../Config";
import axios from "axios";
import { useQuery } from "react-query";
import SelectRoom from "./SelectRoom";
import * as Yup from "yup";
import AddTenantPage from "./AddTenantPage";

const SelectProperty = ({
    getListMutate,
    handleClose,
    setIsSelectProperty,
    selectedTenant = null,
    source
}) => {
    const user = useSelector((state) => state.UserReducer.user);
    const propertyList = useSelector((state) => state.PropertyReducer.property);
    const formikRef = useRef(null);
    const [showPropertyModal, setShowPropertyModal] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [roomModalOpen, setRoomModalOpen] = useState(false);
    const [roomList, setRoomList] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [addTenant, setAddTenant] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    // Yup Validation Schema
    const validationSchema = Yup.object().shape({
        property: Yup.string().required("Please select a property"),
        roomId: Yup.string().required("Please select a room"),
    });

    useEffect(() => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const fetchListing = async () => {
        if (!selectedProperty) return;
        const response = await axios.get(
            `${Config.apiUrl}/room/available/list/${selectedProperty?.id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            }
        );
        return response.data;
    };

    const {
        isLoading,
        data: roomData,
        refetch,
        error,
    } = useQuery(["roomData", selectedProperty], fetchListing, {
        enabled: false,
        onSuccess: (data) => {
            if (data && data.data) {
                setRoomList(data.data);
            } else {
                setRoomList([]);
            }
        },
        onError: (error) => {
            // console.error("Error fetching rooms:", error);
            setRoomList([]);
        },
    });

    useEffect(() => {
        setSelectedRoom(null);
        setRoomList([]);

        if (selectedProperty) {
            refetch();
        }
    }, [selectedProperty, refetch]);

    useEffect(() => {
        if (formikRef.current && selectedProperty) {
            formikRef.current.setFieldValue("property", selectedProperty.id);
        }
    }, [selectedProperty]);

    useEffect(() => {
        if (formikRef.current && selectedRoom && selectedRoom.length > 0) {
            formikRef.current.setFieldValue("roomId", selectedRoom[0].id);
        }
    }, [selectedRoom]);

    const initialValues = {
        property: selectedProperty ? selectedProperty.id : "",
        roomId: selectedRoom && selectedRoom.length > 0 ? selectedRoom[0].id : "",
    };

    const handleSubmit = (values, { resetForm }) => {
        if (selectedRoom && selectedRoom.length > 0) {
            const room = selectedRoom[0];
            const bed = room.beds && room.beds.length > 0 ? room.beds[0] : null;

            setSelectedData({
                bed: bed,
                room: room,
                property: selectedProperty,
                tenant: selectedTenant,
            });

            setAddTenant(true);
            // setIsSelectProperty(false);
        }
    };

    const filteredProperties = propertyList.filter(
        (property) => property.id !== 0
    );

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        setSelectedRoom(null);
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedOption.id);
            formikRef.current.setFieldValue("roomId", "");
        }
    };

    const handleSingleRoomSelect = (room, setFieldValue) => {
        if (room) {
            setFieldValue("roomId", room.id);
            setSelectedRoom([room]);
        } else {
            setFieldValue("roomId", "");
            setSelectedRoom(null);
        }
        setRoomModalOpen(false);
    };

    const renderSelectedRoom = (selected = []) => {
        if (!selected || !selected.length) return "Select Room";

        const maxToShow = 2;
        const namesToShow = selected
            .slice(0, maxToShow)
            .map((room) => room.roomNum);
        const remainingCount = selected.length - maxToShow;

        return (
            <div className="flex text-left">
                <span>{namesToShow.join(", ")}</span>
                {remainingCount > 0 && (
                    <span className="ml-1">+{remainingCount} more</span>
                )}
            </div>
        );
    };

    const handleRefresh = () => {
        setIsSelectProperty(false);
        getListMutate();
    };

    const vacantBedProperties = propertyList.filter(
        (prop) => prop.id !== 0 && (prop.vacantBedCount || 0) > 0
    );

    return (
        <>
            {!addTenant && (
                <Container
                    style={{
                        height: `${height}px`,
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                    }}
                >
                    <ModalHeader>
                        <h1 className="text-white text-lg font-medium">Add Tenant</h1>
                        <button onClick={handleClose}>
                            <MdClose color="white" size={24} />
                        </button>
                    </ModalHeader>

                    {/* <DrawerHeader
                        title="Add Tenant"
                        subtitle="Operational activity logs"
                        icon={<FiActivity />}
                        onClose={handleClose}
                    /> */}

                    <div className="px-6 h-full flex flex-col justify-between">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            innerRef={formikRef}
                            enableReinitialize
                        >
                            {({ values, handleChange, setFieldValue, errors, touched }) => {
                                return (
                                    <Form>
                                        <ModalSubHeading>Step 1</ModalSubHeading>
                                        <ModalHeading>Select Property</ModalHeading>
                                        <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                            <Wrapper>
                                                {filteredProperties &&
                                                    filteredProperties.length > 0 && (
                                                        <InputGroup>
                                                            <Label>Select property *</Label>
                                                            <CategoryCard
                                                                title="Property"
                                                                selectedCategory={selectedProperty}
                                                                onClick={() => setShowPropertyModal(true)}
                                                            />
                                                            {errors.property && touched.property && (
                                                                <div className="text-red-500 text-sm mt-1">
                                                                    {errors.property}
                                                                </div>
                                                            )}
                                                        </InputGroup>
                                                    )}

                                                <InputGroup>
                                                    <Label>Select Room *</Label>
                                                    {selectedProperty ? (
                                                        roomList.length > 0 ? (
                                                            <>
                                                                <CategoryCard
                                                                    title="Room"
                                                                    selectedCategory={
                                                                        selectedRoom && selectedRoom.length > 0
                                                                            ? {
                                                                                label:
                                                                                    renderSelectedRoom(selectedRoom),
                                                                                items: selectedRoom,
                                                                            }
                                                                            : null
                                                                    }
                                                                    onClick={() => setRoomModalOpen(true)}
                                                                />
                                                                {errors.roomId && touched.roomId && (
                                                                    <div className="text-red-500 text-sm mt-1">
                                                                        {errors.roomId}
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="w-full h-11 px-2 py-3 items-center border border-gray-200 rounded-lg bg-gray-50 text-center">
                                                                <p className="text-gray-500 text-sm">
                                                                    {isLoading
                                                                        ? "Loading rooms..."
                                                                        : "No rooms available in this property"}
                                                                </p>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div className="w-full h-11 px-2 py-3 items-center border border-gray-200 rounded-lg bg-gray-50 text-center">
                                                            <p className="text-gray-500 text-sm">
                                                                Please select a property first
                                                            </p>
                                                        </div>
                                                    )}
                                                </InputGroup>
                                            </Wrapper>
                                        </ScrollableContent>
                                        <ActionSection>
                                            <SideCancelBtn type="button" onClick={handleClose}>
                                                Cancel
                                            </SideCancelBtn>
                                            <SubmitBtn
                                                type="submit"
                                                disabled={isLoading || !selectedRoom}
                                            >
                                                {isLoading ? "Processing..." : "Next"}
                                            </SubmitBtn>
                                        </ActionSection>

                                        {/* Property Selection Modal */}
                                        <SinglePropSelectModal
                                            isOpen={showPropertyModal}
                                            onClose={() => setShowPropertyModal(false)}
                                            onSelect={handleSelectedProperty}
                                            options={vacantBedProperties}
                                            selectedProperty={selectedProperty}
                                        />

                                        {/* Room Selection Modal */}
                                        <SelectRoom
                                            isOpen={roomModalOpen}
                                            onClose={() => setRoomModalOpen(false)}
                                            onSelect={(room) =>
                                                handleSingleRoomSelect(room, setFieldValue)
                                            }
                                            options={roomList}
                                            selectedItem={selectedRoom}
                                            title="Select Room"
                                            searchPlaceholder="Search rooms..."
                                            idKey="id"
                                            nameKey="roomNum"
                                            descriptionKeys={["amenities"]}
                                            emptyMessage="No rooms available"
                                            noResultsMessage="No rooms found"
                                            showClearSelection={true}
                                        />
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </Container>
            )}
            {/* Add Tenant Page Modal */}
            {addTenant && (
                <AddTenantPage
                    setAddTenant={setAddTenant}
                    addTenant={addTenant}
                    selectedData={selectedData}
                    getListMutate={getListMutate}
                    propId={selectedProperty?.id}
                    setIsSelectProperty={setIsSelectProperty}
                    handleRefresh={handleRefresh}
                    route="selectProperty"
                    selectedTenant={selectedTenant}
                    source={source}
                />
            )}
        </>
    );
};

const Label = tw.label`text-sm text-gray-500 font-normal `;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;

export default SelectProperty;
